'use strict';

angular.module('TurneroApp').component('coSidebar', {
	bindings: {
		usuario: '<',
		centrosAtencion: '<',
		centroAtencionSeleccionado: '<',
		centroAtencionCallback: '&'
	},
	controller: [
		 '$state',
		 'menuService',
		 'utilsService',
		 '$rootScope',
		 'seguridadService',
	    '$localStorage',
	function ($state, menuService, utilsService, $rootScope, seguridadService, $localStorage) {
		var ctrl = this;
		var redirectState;
		ctrl.target = ''
		ctrl.isOpenDialog = false;

		ctrl.redirect = function (menu) {

			var state = menu.Url;

			if (state) {
				if (menu.Usa_Centro === 'S') {
					if (state == "admin.atencion") {
						ctrl.target = '_blank';
					}
					if (!ctrl.centroAtencionSeleccionado || !ctrl.centroAtencionSeleccionado.id) {
						ctrl.isOpenDialog = true;
						redirectState = state;
					}
					else {
						if ($state.current.name == state) {
							$state.dispose();
							$state.reload();
						} else {
							$state.dispose();
							var url = $state.href(state);
							ctrl.target && state != "admin.atencion" ? window.open(url, ctrl.target) : $state.go(state);
						}

					}
				}
				else {
					$state.dispose();
					$state.go(state);
				}
			}
			else {
				!menu.isOpen && ctrl.menuAgente.forEach(function (menu) {
					menu.isOpen = false;
				});

				menu.isOpen = !menu.isOpen;
			}
		};

		ctrl.openDialog = function () {
			ctrl.isOpenDialog = true;
		};

		ctrl.cambiarCentroDeAtencion = function (centroAtencionSeleccionado) {

			ctrl.centroAtencionCallback({ centroAtencionSeleccionado: centroAtencionSeleccionado });

			$state.go(redirectState);

			ctrl.onCloseDialog();
		};

		ctrl.onCloseDialog = function () {
			ctrl.isOpenDialog = false;
		};

        ctrl.menuReload = function () {
            var id_centro = 0;

            if (ctrl.centroAtencionSeleccionado.id !== undefined) {
                id_centro = ctrl.centroAtencionSeleccionado.id;
            }

            if (id_centro == 0) {
                
                seguridadService.permisos = "";
                $localStorage.TurneroApp_Authorization.usuario.permisos = "";

                ctrl.menuAgente = {};
                $rootScope.$$phase != '$digest' ? $rootScope.$digest() : '';
            }
            else {
                menuService.get({ 'id_centro_atencion': id_centro }).$promise.then(function (data) {

                    var listMenu = data.Data;

                    if (data.Permisos) {
                        seguridadService.permisos = data.Permisos;
                        $localStorage.TurneroApp_Authorization.usuario.permisos = data.Permisos;
                    }

                    var map = {}, menu, menuAgente = [];
                    for (var i = 0; i < listMenu.length; i += 1) {

                        menu = listMenu[i];
                        menu.children = [];
                        map[menu.Id_Menu] = i; // use map to look-up the parents

                        if (menu) {

                            if (menu.Id_Menu_Padre !== 0) {
                                listMenu[map[menu.Id_Menu_Padre]].children.push(menu);
                            } else {

                                var menuHijo = listMenu[i + 1];
                                if (menuHijo !== undefined) {
                                    if (menuHijo.Id_Menu_Padre == menu.Id_Menu) {
                                        menu.Tiene_Hijos = true;
                                        menu.isOpen = false;
                                        menuAgente.push(menu);
                                    }
                                    else {
                                        if (!menu.Tiene_Hijos) {
                                            menu.Tiene_Hijos = false;
                                            menu.isOpen = false;
                                            menuAgente.push(menu);
                                        }
                                    }
                                }
                                else {
                                    if (!menu.Tiene_Hijos) {
                                        menu.Tiene_Hijos = false;
                                        menu.isOpen = false;
                                        menuAgente.push(menu);
                                    }
                                }
                            }

                        }
                    }

                    ctrl.menuAgente = menuAgente;
                    $rootScope.$$phase != '$digest' ? $rootScope.$digest() : '';

                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }
        };

        ctrl.$onChanges = function (changesObj) {

            try {
                if (ctrl.usuario) {
                    ctrl.menuReload();
                }
            }
            catch (e) {
                utilsService.errores(e);
            }
        };
	}
	],
	template: require('./sidebar.html')
});



// WEBPACK FOOTER //
// ./app/shared/sidebar/sidebarComponent.js